import {
  api_OpenSalesOrderForCustomerMobileApp,
  api_UpdateSkipRatings,
  api_SubmitRatings,
} from "../../connection/api/api-orders";
import {
  CONCAT_TEXT_LIMIT,
  HEADER_TAB_SETUP,
  KEY_GENERATOR,
} from "../../functions/funtion";
import {
  GET_SET_STORED_DATA,
  GET_PAGE_URL,
} from "../../database/get-stored-data";
import { api_LoadCompletedSalesOrderForCustomerMobileApp } from "../../connection/api/api-profile";
import { PT_ORDERS, PT_VIEWINVOICE } from "../../routes/stack/paths/pt-orders";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { SET_STORE_PAGE_URL } from "../../database/store-data";
import { F_Fammily, Font } from "../../util/config-fonts";
import { STORE_PAGE_URL } from "../../database/store-names";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { PT_SIGNIN } from "../../routes/stack/paths/pt-profile";
import { Colors } from "../../util/colors";
import React from "react";
import "../../styles/css/RateNow.css";

export default class COMPLETEDORDERS extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      MobileLoadCompletedSalesInvoice: [],
      isDataEmpty: false,
      showRateModal: false,
      selectedPosId: null,
      merchantRating: 0,
      riderRating: 0,
      itemRatings: [],
      items: [],
      Merchant: null,
      DeliveryCharges: null,
      Rider: null,
    };
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    if (this.props.CSID !== 0) {
      await this.LoadCompleteOrders();
    }

    if (!this.props.hideHeader) {
      var a = await GET_PAGE_URL();
      await HEADER_TAB_SETUP({
        HeaderTabName: CONCAT_TEXT_LIMIT({
          length: 20,
          string: "Completed Orders",
        }),
        FnGoBackScreen: () => {
          this.props.navigate(a);
          ENCRYPT_STORAGE.removeItem(STORE_PAGE_URL);
        },
        HeaderNavigatorMenuDisplay: false,
        FnHeaderNavigatorMenu: () => {},
      });
    }
  }

  async LoadCompleteOrders() {
    let data = await api_LoadCompletedSalesOrderForCustomerMobileApp();
    let objData = JSON.parse(data);
    if (objData !== "[[]]" && data !== '"[]"') {
      this.setState({ MobileLoadCompletedSalesInvoice: [] });
      let objobjData = JSON.parse(objData);
      this.setState({
        MobileLoadCompletedSalesInvoice: objobjData[0],
        isDataEmpty: false,
      });
    } else {
      this.setState({ isDataEmpty: true });
    }
  }

  async LoadItemsForRating(x) {
    let data = await api_OpenSalesOrderForCustomerMobileApp(x);
    let objdata = JSON.parse(data);
    let objobjdata = JSON.parse(objdata);
    let ObjSalesOrderHeader = objobjdata[1][0];

    this.setState({
      items: objobjdata[0],
      Merchant: ObjSalesOrderHeader.Merchant,
      DeliveryCharges: ObjSalesOrderHeader.DineType,
      Rider: ObjSalesOrderHeader.Rider,
    });
  }

  handleRating = (category, rating) => {
    if (category === "merchantRating") {
      this.setState({ merchantRating: rating });
    } else if (category === "riderRating") {
      this.setState({ riderRating: rating });
    } else if (category.startsWith("itemRating_")) {
      const itemIndex = parseInt(category.split("_")[1]);
      const updatedItemRatings = [...this.state.itemRatings];
      updatedItemRatings[itemIndex] = {
        ...updatedItemRatings[itemIndex],
        PID: this.state.items[itemIndex].PID,
        LineID: this.state.items[itemIndex].LineID,
        rating,
      };
      this.setState({ itemRatings: updatedItemRatings });
    }
  };

  renderStarss = (category, index) => {
    let currentRating;
    if (category.startsWith("itemRating_")) {
      const itemIndex = parseInt(category.split("_")[1]);
      currentRating = this.state.itemRatings[itemIndex]?.rating || 0;
    } else {
      currentRating = this.state[category] || 0;
    }

    return [1, 2, 3, 4, 5].map((starIndex) => (
      <span
        key={starIndex}
        className={`star ${starIndex <= currentRating ? "filled" : ""}`}
        onClick={() => this.handleRating(category, starIndex, index)}
      >
        {starIndex <= currentRating ? (
          <i className="bi bi-star-fill"></i>
        ) : (
          <i className="bi bi-star"></i>
        )}
      </span>
    ));
  };

  handleSubmitRating = async () => {
    const ratings = {
      merchantRating: this.state.merchantRating,
      riderRating: this.state.riderRating,
      itemRatings: this.state.itemRatings,
    };
    // console.log(ratings);

    await api_SubmitRatings(ratings, this.state.selectedPosId);
    this.setState({
      merchantRating: 0,
      riderRating: 0,
      itemRatings: [],
    });
    this.toggleRateModal();
    await this.LoadCompleteOrders();
  };

  SkipRating = async () => {
    await api_UpdateSkipRatings(this.state.selectedPosId);
    this.toggleRateModal();
    this.setState({
      merchantRating: 0,
      riderRating: 0,
      itemRatings: [],
      items: [],
    });
    await this.LoadCompleteOrders();
  };

  toggleRateModal = (posId) => {
    this.setState((prevState) => ({
      showRateModal: !prevState.showRateModal,
      selectedPosId: posId,
    }));
  };

  renderStars = (mRate) => {
    const filledStars = Math.floor(mRate); // Number of filled stars
    const starComponents = [];

    for (let i = 1; i <= 5; i++) {
      if (i <= filledStars) {
        // Render a filled star
        starComponents.push(
          <i
            key={i}
            className="bi bi-star-fill"
            style={{ fontSize: "20px", color: "#FFD700", paddingRight: "4px" }}
          ></i>
        );
      } else {
        // Render an empty star
        starComponents.push(
          <i
            key={i}
            className="bi bi-star"
            style={{ fontSize: "20px", color: "#D3D3D3", paddingRight: "4px" }}
          ></i>
        );
      }
    }

    return starComponents;
  };

  render() {
    if (dto_Customer.CSID === 0) {
      return (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "350px",
              height: "100vh",
            }}
          >
            <button
              style={{
                width: "40%",
                height: "48px",
                borderRadius: "6px",
                fontFamily: F_Fammily.Regular,
                backgroundColor: Colors.DarkGreyScale,
                textAlign: "center",
                alignItems: "center",
                color: "#fff",
                fontSize: Font.MainHeading,
                border: "none",
                cursor: "pointer",
                marginTop: "",
              }}
              onClick={async () => {
                await SET_STORE_PAGE_URL(PT_ORDERS);
                this.props.navigate(PT_SIGNIN);
              }}
            >
              Please Sign-In
            </button>
          </div>
        </>
      );
    }

    const { DeliveryCharges } = this.state;
    const displayRiderRating = DeliveryCharges === 4;

    return (
      <div
        className="addListHeaderr fadateInUp animed"
        style={{ marginTop: this.props.hideHeader ? "20px" : "60px" }}
      >
        {this.state.showRateModal && (
          <div className="modalbg">
            <div className="modalbody" onClick={(e) => e.stopPropagation()}>
              <h3
                className="cardd"
                style={{
                  textAlign: "center",
                  backgroundColor: Colors.DarkGreyScale,
                }}
              >
                How would you rate ?
              </h3>

              <div>
                {/* merchant Rating */}
                <div className="card">
                  <div className="Hitem-rating-label">MERCHANT RATING</div>
                  <div className="item-rating-container">
                    <label className="item-rating-label">
                      {this.state.Merchant} <i className="bi bi-shop" />{" "}
                    </label>
                    <div>{this.renderStarss("merchantRating", -1)}</div>
                  </div>
                </div>

                {/* Rider Rating */}
                {displayRiderRating && (
                  <div className="card">
                    <div className="Hitem-rating-label">RIDER RATING</div>
                    <div className="item-rating-container">
                      <label className="item-rating-label">
                        {" "}
                        {
                          this.state.Rider
                        } <i className="fa fa-motorcycle" />{" "}
                      </label>
                      <div>{this.renderStarss("riderRating", -1)}</div>
                    </div>
                  </div>
                )}

                {/* Add Item Ratings Section */}
                <div className="card">
                  <div className="Hitem-rating-label">ITEM RATING</div>
                  {this.state.items.map((item, index) => {
                    // Check if item should be skipped based on PID
                    if (item.PID === 1224929 || item.PID === 73163) {
                      return null;
                    }

                    return (
                      <div key={index} className="item-rating-container">
                        <label className="item-rating-label">{item.Desc}</label>
                        <div>
                          {this.renderStarss(`itemRating_${index}`, index)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "fit-content",
                    fontWeight: "bold",
                    marginTop: "30px",
                    marginBottom: "10px",
                    textAlign: "center",
                    backgroundColor: Colors.DarkGreyScale,
                    color: "white",
                    padding: 15,
                    borderRadius: "10px",
                    cursor: "pointer",
                  }}
                  onClick={this.handleSubmitRating}
                >
                  Submit Rating
                </div>

                {/* Close icon*/}
                <span
                  onClick={this.SkipRating}
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  No, Thanks
                </span>
              </div>
            </div>
          </div>
        )}

        {this.state.isDataEmpty ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "60px",
            }}
          >
            <img
              src={require("../orders/components/orders-view/NoDataFound.jpg")}
              width={"60%"}
              alt=""
            />

            <label
              style={{
                fontWeight: "bold",
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              No Orders Found
            </label>
            <label
              style={{
                textAlign: "center",
                display: "block",
              }}
            >
              Try ordering something
            </label>
          </div>
        ) : (
          <div style={{ paddingBottom: "50px" }}>
            {this.state.MobileLoadCompletedSalesInvoice.map((rs) => (
              <div
                className="pgOrderCard"
                key={KEY_GENERATOR()}
                style={{
                  border: "1px solid #ccc",
                  height: 200,
                  borderRadius: "8px",
                  marginBottom: 10,
                }}
              >
                <div style={{ width: "100%", height: 120, display: "flex" }}>
                  <div
                    style={{
                      width: "75%",
                      marginLeft: "15px",
                      marginTop: "13px",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "left",
                        fontWeight: 600,
                        marginTop: 0,
                      }}
                    >
                      {rs.Merchant.length > 20
                        ? `${rs.Merchant.substring(0, 20)}...`
                        : rs.Merchant}
                    </p>
                    <p style={{ fontSize: 12, textAlign: "left" }}>
                      Order No: {rs.GUNO}
                    </p>
                    <p style={{ fontSize: 12, textAlign: "left" }}>
                      {rs.Delivery}
                    </p>
                    <p
                      style={{
                        textAlign: "left",
                        fontFamily: F_Fammily.Regular,
                      }}
                    >
                      Total: {parseFloat(rs.Total).toFixed(2)}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "45%",
                      marginTop: "10px",
                      marginLeft: "5px",
                      marginRight: "5%",
                    }}
                  >
                    <img
                      alt={rs.ImageURL}
                      src={rs.ImageURL}
                      onError={(e) => {
                        e.currentTarget.src = dto_common.DefaultImageUrl;
                      }}
                      style={{
                        border: "1px solid #ccc",
                        height: 100,
                        width: "80%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
                <div>
                  <hr />
                  <div>
                    <button
                      style={{
                        fontFamily: F_Fammily.Medium,
                        width: CSP !== "AV" ? "96%" : "48%", // Adjusted width condition
                        marginRight: "2%",
                        height: 40,
                        borderRadius: "5px",
                        fontSize: "medium",
                        backgroundColor:
                          CSP === "AV" ? "white" : Colors.DarkGreyScale,
                        color: CSP === "AV" ? Colors.DarkGreyScale : "white",
                        border: "1px solid Colors.DarkGreyScale",
                        display: CSP === "DT" ? "block" : "inline-block", // Adjusted display condition
                      }}
                      onClick={() => {
                        const pageType = this.props.hideHeader
                          ? "ordercompleted"
                          : "completed";
                        this.props.navigate(
                          PT_VIEWINVOICE.replace(":frmPage", pageType).replace(
                            ":orderID",
                            rs.POSID
                          )
                        );
                      }}
                    >
                      View Order
                    </button>

                    {CSP === "AV" && ( // Only render the following buttons if CSP === 'AV'
                      <>
                        {rs.Feedback === 1 ? (
                          <button
                            style={{
                              fontFamily: F_Fammily.Medium,
                              width: "48%",
                              marginLeft: "2%",
                              height: 40,
                              borderRadius: "5px",
                              fontSize: "medium",
                              backgroundColor: "white",
                              color: Colors.DarkGreyScale,
                              border: "none",
                            }}
                          >
                            {this.renderStars(rs.MRate)}
                          </button>
                        ) : (
                          <button
                            style={{
                              fontFamily: F_Fammily.Medium,
                              width: "48%",
                              marginLeft: "2%",
                              height: 40,
                              borderRadius: "5px",
                              fontSize: "medium",
                              backgroundColor: "white",
                              color: Colors.DarkGreyScale,
                              border: "1px solid Colors.DarkGreyScale",
                            }}
                            onClick={() => {
                              this.toggleRateModal(rs.POSID);
                              this.LoadItemsForRating(rs.POSID);
                            }}
                          >
                            Rate Now
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}
